import React from "react";
import TravelerListWrapper from "./travelerList.style";
import { withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { updateApplicant } from "../../../../redux/actions/travel";
import removeIcon from "../../../../assets/images/remove-icon.svg";

const TravelerListItem = ({ t, person, lang, onDelete }) => {
  const {
    fullNameArabic,
    fullNameEnglish,
    nationalId,
    dobHijri,
    dobGreg,
    relationCode,
  } = person;

  return (
    <div className={"row table-design mb-4 "}>
      {/* {relationCode !== "Self" && (
        <div className="col-1">
          <div className="round-box">
            <i className="pi pi-check" />
          </div>
        </div>
      )} */}
      <div
        className={`col-12 ${
          relationCode === "Self"
            ? "col-md-7 col-md-7-width"
            : "col-md-6 col-md-6-width"
        } ps-4 ps-md-0 pe-md-4`}
      >
        <div className="d-flex justify-content-between align-items-center div-content1">
          <div className="text-initial">
            <div className="text1">{t("name-as-on-passport")}</div>
            <div className="text2">
              {/* {lang === "ar" ? fullNameArabic : fullNameEnglish} */}
              {fullNameEnglish}

            </div>
          </div>
          <div className="edit-style">
            <img onClick={onDelete} src={removeIcon} width={15} />
          </div>
        </div>
      </div>
      <div className="offset-1 col-11 offset-md-0 col-md-3 col-md-3-width ps-4">
        <div className="d-flex justify-content-between div-content2">
          <div className="text-initial">
            <div className="text1">{t("saudi-id")}</div>
            <div className="text2 lato">{nationalId}</div>
          </div>
          <div className="text-initial d-block d-md-none me-5">
            <div className="text1">{t("DateOfBirth")}</div>
            <div className="text2 lato">{ dobGreg}</div>
          </div>
        </div>
      </div>
      {/* { relationCode !== 'Self' && <div className="offset-1 col-11 offset-md-0 col-md-2 col-md-2-width ps-4">
                <div className='text-initial div-content3'>
                    <div className='text1'>{t('relationship')}</div>
                    <div className='text2'>{ relationCode }</div>
                </div>
            </div>
            } */}
      <div className="offset-1 col-11 offset-md-0 col-md-2 col-md-2-width ps-4 d-none d-md-block">
        <div className="text-initial div-content4">
          <div className="text1">{t("YEAR_OF_BIRTH")}</div>
          <div className="text2 lato">{dobGreg}</div>
        </div>
      </div>
    </div>
  );
};

const TravelerList = (props) => {
  const dispatch = useDispatch();

  let { self, applicants } = useSelector((state) => state.travel.applicants);
  const deletePerson = (nationalId, isSelf) => {
    if (isSelf) {
      dispatch(updateApplicant({ self: {}, applicants: [] }));
    } else {
      applicants = applicants.filter((ele) => ele.nationalId !== nationalId);
      // dispatch(updateApplicant({self,applicants}));
      dispatch(updateApplicant({ self: {}, applicants: [] }));
    }
  };
  return (
    <TravelerListWrapper>
      {props.selfView && self && self.nationalId && (
        <TravelerListItem
          t={props.t}
          person={self}
          onDelete={() => deletePerson(-1, true)}
          lang={props.i18n.language}
        />
      )}
      {props.applicantsView &&
        applicants &&
        !!applicants.length &&
        applicants.map((ele, index) => {
          return (
            <TravelerListItem
              key={index}
              t={props.t}
              person={ele}
              onDelete={() => deletePerson(ele.nationalId)}
              lang={props.i18n.language}
            />
          );
        })}
    </TravelerListWrapper>
  );
};

export default withTranslation()(TravelerList);
